import { applyBlockedImages, restoreImages } from './toggleImages';

// `toggle-images` — a togglable canvas command wired to the toolbar button in config/panels.js.
// run() when the button is activated (preview images blocked), stop() when deactivated (restore).
export default (editor) => {
  const cmd = editor.Commands;

  cmd.add('toggle-images', {
    run(ed) {
      applyBlockedImages(ed.Canvas.getDocument());
    },
    stop(ed) {
      restoreImages(ed.Canvas.getDocument());
    },
  });
};
